<div class="chart-layout-container" [id]="card.id"></div>
<ng-content></ng-content>
